import { createRouter, createWebHistory } from 'vue-router'

function toExternalLink() {
    window.location.href = 'https://www.example.com'; // 重定向到外部链接
}

const routes = [
    {
        path: '/test',
        name: 'test',
        component: () => import('./views/TestView.vue'),
        meta: {
            title: 'iTrain Test'
        }
    },
    {
        path: '/yolo',
        name: 'yolo',
        component: () => import('./views/YoloView.vue'),
        meta: {
            title: 'iTrain Yolo'
        }
    },
    {
        path: '/od',
        name: 'od',
        component: () => import('./views/OdView.vue'),
        meta: {
            title: 'iTrain OD'
        }
    },
    {
        path: '/audio',
        name: 'audio',
        component: () => import('./views/AudioView3.vue'),
        meta: {
            title: 'iTrain Audio'
        }
    },
    {
        path: '/pose',
        name: 'pose',
        component: () => import('./views/PoseView3.vue'),
        meta: {
            title: 'iTrain Pose'
        }
    },
    {
        path: '/face',
        name: 'face',
        component: () => import('./views/FaceView.vue'),
        meta: {
            title: 'iTrain Face Recognition'
        }
    },
    {
        path: '/image',
        name: 'image',
        component: () => import('./views/ImageView3.vue'),
        meta: {
            title: 'iTrain Image'
        }
    },
    {
        path: '/',
        name: 'home',
        component: () => import('./views/HomeView.vue'),
        meta: {
            title: 'iTrain'
        }
    },
    {
        path: '/models/:path',
        name: 'models',
        component: () => import('./views/ModelView.vue'),
        meta: {
            title: 'iTrain Model'
        }
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    next();

    if (to.meta.title) {
        document.title = to.meta.title
    } else {
        document.title = 'iTrain'
    }
});

export default router
